import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { AUTH_API } from "./apiRoutes";

const mutateLogin = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${AUTH_API}/login`, data);
};

const useLoginMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateLogin,
    ...queryParams,
  });

export default useLoginMutation;
